import functions from "./functions.js";
// import inputPopover from "./input-popover.js";

$(function() {
    
    $(document).on('click', '.input-group-append', function (e) {
        let $elem = $(e.target).closest('.form-group').find('.form-control');
        $elem.focus() && $elem.hasClass('select2') && $elem.select2('open');
    });


    // menu links active
    const path = location.pathname.replace(/\/$/, '');
    $('.main-header [href], footer [href]').each((i, link) => {
        let href = link.getAttribute('href');
        if ( href && href != '#' ) {
            href = href.split('?')[0].replace(/\/$/, '');
            if ( path === href ) {
                $(link).addClass('active').closest('.nav-item').addClass('active');
            }
        }
    });

    // global tooltip init
    //('[data-toggle="tooltip"]').tooltip();

    // mobile menu handling
    (() => {
        const $header = $('.main-header');
        const $dropdownLinks = $header.find('.main-menu .nav-item.dropdown .nav-link');
        const $collapser = $header.find('.navbar-collapse');

        $dropdownLinks.on('click', e => {
            if ( document.documentElement.clientWidth >= 992 ) {
                return;
            }
            if ( e.currentTarget.classList.contains('show-dropdown') ) {
                e.currentTarget.classList.remove('show-dropdown');
            } else {
                $dropdownLinks.removeClass('show-dropdown');
                e.currentTarget.classList.add('show-dropdown');
            }
        });

        // ensure navbar toggler also open closes main-menu
        $collapser
            .on('show.bs.collapse', () => {
                document.body.classList.add('modal-transition');
                document.body.classList.add('modal-active');
            })
            .on('hide.bs.collapse', () => {
                $dropdownLinks.removeClass('show-dropdown');
                document.body.classList.remove('modal-active');
            })
            .on('hidden.bs.collapse', () => {
                document.body.classList.remove('modal-transition');
            });
    })();

    // home slider init
    const $sliderMain = $("#slider-main");
    const $sliderMainItemsBg = $sliderMain.find('.slide-bg');
    const sliderAnim = (e, i) => {
        $sliderMainItemsBg.removeClass('active');
        $sliderMainItemsBg.eq(i || 0).addClass('active');
    };
    $sliderMain.lightSlider({
        item: 1,
        mode: 'fade',
        pager: false,
        slideMargin: 0,
        pauseOnHover: true,
        loop: true,
        auto: true,
        pause: 6500,
        speed: 500,
        enableDrag: false,
        prevHtml: '<i class="fa fa-angle-left"></i>',
        nextHtml: '<i class="fa fa-angle-right"></i>',
        onSliderLoad: sliderAnim,
        onAfterSlide: sliderAnim
    });

    // slider offers init
    $("#slider-destinations").lightSlider({
        item: 1,
        slideMargin: 0,
        pauseOnHover: true,
        loop: true,
        //auto: true,
        pager: false,
        pause: 5000,
        speed: 500,
        enableDrag: false,
        controls: true,
        prevHtml: '<span class="text-secondary"><i class="la la-angle-left la-2x"></i></span>',
        nextHtml: '<span class="text-secondary"><i class="la la-angle-right la-2x"></i></span>'
    });



    $("#slider-home").lightSlider({
        item: 1,
        slideMargin: 0,
        pauseOnHover: true,
        loop: true,
        auto: true,
        pager: false,
        pause: 5000,
        speed: 500,
        enableDrag: false,
        controls: false,
        prevHtml: '<i class="las la-angle-left text-white la-3x p-1 rounded" style="background-color: #393844cc;"></i>',
        nextHtml: '<i class="las la-angle-right text-white la-3x p-1 rounded" style="background-color: #393844cc;"></i>'
    });
    $("#slider-home2").lightSlider({
        item: 1,
        slideMargin: 0,
        pauseOnHover: true,
        loop: true,
        auto: false,
        pager: false,
        pause: 5000,
        speed: 500,
        enableDrag: true,
        controls: true,
        prevHtml: '<span class="text-light"><i class="la la-angle-left la-3x"></i></span>',
        nextHtml: '<span class="text-light"><i class="la la-angle-right la-3x"></i></span>'
    });
    $("#slider-home3").lightSlider({
        item: 1,
        slideMargin: 0,
        pauseOnHover: true,
        loop: true,
        auto: false,
        pager: false,
        pause: 5000,
        speed: 500,
        enableDrag: true,
        controls: true,
        prevHtml: '<span class="text-light"><i class="la la-angle-left la-3x"></i></span>',
        nextHtml: '<span class="text-light"><i class="la la-angle-right la-3x"></i></span>'
    });
    $(".slider-category").lightSlider({
        item: 3,
        slideMargin: 0,
        //pauseOnHover: true,
        loop: false,
        auto: false,
        pager: true,
        //pause: 5000,
        speed: 800,
        enableDrag: true,
        controls: true,
        prevHtml: '<span class=""><i class="la la-angle-left la-2x"></i></span>',
        nextHtml: '<span class=""><i class="la la-angle-right la-2x"></i></span>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    item: 2
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    item: 1
                }
            }
        ]
    });
    $(".card-img-slider").lightSlider({
        item: 1,
        slideMargin: 0,
        //pauseOnHover: true,
        loop: true,
        auto: false,
        pager: false,
        //pause: 5000,
        speed: 800,
        //enableDrag: true,
        controls: true,
        prevHtml: '<i class="las la-angle-left text-white p-1 rounded" style="font-size: 1.1rem; background-color: #393844cc;"></i>',
        nextHtml: '<i class="las la-angle-right text-white p-1 rounded" style="font-size: 1.1rem; background-color: #393844cc;"></i>'
    });
    $(".charter-detail-slider").lightSlider({
        item: 3,
        slideMargin: 0,
        //pauseOnHover: true,
        loop: true,
        auto: false,
        pager: false,
        //pause: 5000,
        speed: 800,
        enableDrag: false,
        controls: true,
        prevHtml: '<i class="las la-angle-left text-white p-1 rounded" style="font-size: 1.8rem; background-color: #393844cc;"></i>',
        nextHtml: '<i class="las la-angle-right text-white p-1 rounded" style="font-size: 1.8rem; background-color: #393844cc;"></i>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    item: 2
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    item: 1
                }
            }
        ]
    });

    $("#trips-slider").lightSlider({
        item: 3,
        slideMargin: 0,
        //pauseOnHover: true,
        loop: true,
        auto: false,
        pager: false,
        //pause: 5000,
        speed: 800,
        enableDrag: false,
        controls: true,
        prevHtml: '<i class="las la-angle-left text-white p-1 rounded" style="font-size: 1.8rem; background-color: #393844cc;"></i>',
        nextHtml: '<i class="las la-angle-right text-white p-1 rounded" style="font-size: 1.8rem; background-color: #393844cc;"></i>',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    item: 2


                    
                }
            },
            {
                breakpoint: 1000,
                settings: {
                    item: 1
                }
            }
        ]
    });

    /*$(".excursion-unit-detail").lightSlider({
        item: 3,
        slideMargin: 0,
        //pauseOnHover: true,
        loop: false,
        auto: false,
        pager: true,
        //pause: 5000,
        //speed: 800,
        enableDrag: false,
        controls: true,
        prevHtml: '<i class="las la-angle-left text-white p-1 rounded" style="font-size: 1.8rem; background-color: #393844cc;"></i>',
        nextHtml: '<i class="las la-angle-right text-white p-1 rounded" style="font-size: 1.8rem; background-color: #393844cc;"></i>',

        /*item: 3 ,
        slideMargin: 2,
        autoWidth: true,
        sliderMove: 1,
        vertical: false,
        enableDrag: false,
        controls: true,
        prevHtml: '<i class="las la-angle-left text-white p-1 rounded" style="font-size: 1.8rem; background-color: #393844cc;"></i>',
        nextHtml: '<i class="las la-angle-right text-white p-1 rounded" style="font-size: 1.8rem; background-color: #393844cc;"></i>'
        
        
    });*/

    /* gallery */
    const lg = {};
    window.showGallery = (index, id) => {
        index = +index || 0;
        if ( lg[id] ) {
            lg[id].index = index;
            lg[id].build(index);
        } else {
            lg[id] = $('#' + id).lightGallery({
                dynamic: true,
                thumbnail: true,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                preload: 2,
                index: index,
                dynamicEl: JSON.parse($('[data-images-' + id + ']').attr('data-images-' + id))
            }).data('lightGallery');
        }
    };
    $('[data-gallery-id]').on('click', function (e) {
        e.preventDefault();
        let galleryId = $(this).attr('data-gallery-id');
        galleryId && showGallery($(this).attr('data-index'), galleryId);
    });
    $('.btn-slider-gallery').on('click', e => {
        $(e.currentTarget).parent().find('.lslide.active').click();
    });
    /* end gallery */

    // scrool to element handling
    $(document).on('click', '[data-scroll-to]', e => {
        e.preventDefault();
        const $this = $(e.target);
        let scrollTo = $this.attr('data-scroll-to').split(',');
        functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
    });
    
    // global datepicker init with automatic "dateTo" set if provided
    let displayDate = new Date('2019-06-01');
    let now = functions.cleanDate(new Date);
    if ( now > displayDate ) {
        displayDate = now;
    }

    $('.datepicker-range').each((i, elem) => {
        const $datepicker = $(elem);
        const minDate = $datepicker.attr('data-min');
        const maxDate = $datepicker.attr('data-max');
        $datepicker.flatpickr({
            mode: "range",
            altInput: true,
            wrap: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            minDate: minDate ? minDate : now,
            maxDate: maxDate ? maxDate : null,
            disableMobile: true,
            prevArrow: '<i class="fa fa-chevron-circle-left fa-fw fa-2x pr-2"></i>',
            nextArrow: '<i class="fa fa-chevron-circle-right fa-fw fa-2x pl-2"></i>',
            locale: {
                rangeSeparator: ' - '
            }
        });
        // to style clear toggler
        $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
    });  

    $('.datepicker').each((i, elem) => {
        const $datepicker = $(elem);
        const minDate = $datepicker.attr('data-min');
        const maxDate = $datepicker.attr('data-max');
        $datepicker.flatpickr({
            altInput: true,
            wrap: true,
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",
            minDate: minDate ? minDate : now,
            maxDate: maxDate ? maxDate : null,
            disableMobile: true,
            prevArrow: '<i class="la la-angle-left pr-2"></i>',
            nextArrow: '<i class="la la-angle-right pl-2"></i>',
            onChange(selectedDates, dateStr, instance) {

                const $first = $(instance.input);
                // prevent other logic if second datepicker is triggered by first
                if (instance._openByFirst) {
                    delete instance._openByFirst;
                    return;
                }
                
                if ($first.attr('data-firstDate')) {
                    const $second = $first.closest('form').find('[data-secondDate]').closest('.datepicker');
                    if ($second.length) {

                        var firstDate = new Date(selectedDates[0]);
                        firstDate.setDate(firstDate.getDate() + 1);
                        
                        var secondInstance = $second[0]._flatpickr;
                        // check if firstDate is invalid
                        if (firstDate.getTime() === firstDate.getTime()) {
                            secondInstance._openByFirst = true;
                            secondInstance.set('minDate', firstDate);
                            if (!secondInstance.selectedDates[0]) {
                                firstDate.setDate(firstDate.getDate() + 6);
                                secondInstance.setDate(firstDate);
                            }
                            secondInstance.open();
                            $(secondInstance.altInput).focus();
                        }
                        else if (secondInstance.selectedDates[0]) {
                            secondInstance.clear();
                        }
                    }
                }
                // check if second date is cleared
                else if ($first.attr('data-secondDate') && !selectedDates[0]) {
                    $first.closest('form').find('[data-firstDate]').closest('.datepicker')[0]._flatpickr.clear();
                }
            },
            onOpen(selectedDates, dateStr, instance) {
                if (instance.input.getAttribute('data-secondDate')) {
                    const $first = $(instance.input).closest('form').find('[data-firstDate]').closest('.datepicker');
                    if ($first.length) {
                        const firstInstance = $first[0]._flatpickr;
                        if (!firstInstance.input.value) {
                            instance.close();
                            firstInstance.open();
                            firstInstance.altInput.focus();
                            return;
                        }
                    }
                }
                !dateStr && instance.jumpToDate(minDate ? minDate : displayDate);
            }
        });
        // to style clear toggler
        $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
    });        

    // select2 templates can be defined as data-template="destinations" ...
    const selectTemplates = {
        destinations: data => {
            if ( !data.element ) {
                return data.text;
            }
            const $element = $('<span>').addClass(data.element.className).text(data.text);
            let elemClass;
            switch ( (data.id).split(':').length ) {
                case 3: elemClass = 'pl-2'; break;
                case 4: elemClass = 'pl-3 h6 font-weight-normal'; break;
                default: elemClass = 'h5'; break;
            }
            $element.addClass(elemClass);
            return $element;
        },
        ports: data => {
            if( !data.element ) {
                return data.text;
            }
            const $element = $('<span>').addClass(data.element.className).text(data.text);
            data.element.disabled ? $element.addClass('h5 text-warning-dk') : $element.addClass('pl-2');
            return $element;
        },
        detailsListPrices: data => {
            if ( !data.element ) {
                return data.text;
            }
            const $element = $('<span>').addClass(data.element.className).text(data.text);
            let elemClass;
            switch ( (data.id + '').split('--').length ) {
                case 1: elemClass = 'h5 font-weight-normal text-warning-dk'; break;
                default: elemClass = 'pl-3'; break;
            }
            $element.addClass(elemClass);
            return $element;
        },
        numberPersons: data => {
            if ( !data.element ) {
                return data.text;
            }
            const $element = $('<span>').addClass(data.element.className).text(data.text);
            let elemClass;
            switch ( (data.id + '').split(':').length ) {
                case 1: elemClass = 'text-primary-dk'; break;
                case 2: elemClass = 'h5 font-weight-normal text-warning-dk'; break;
                case 3: elemClass = 'pl-3 h6'; break;
                case 4: elemClass = 'pl-4'; break;
            }
            $element.addClass(elemClass);
            return $element;
        }
    };

    // global init select2
    // data-templates
    // data-data
    // data-allow-clear
    // data-nosearch
    // placeholder
    $.map($('.select2'), elem => {
        const $elem = $(elem);
        const config = { dropdownParent: $elem.parent(), language: functions.getLang() };
        config.allowClear = $elem.attr('data-allow-clear');

        // find select2 which has an attribute data-data
        const data = $elem.attr('data-data');
        if ( data ) {
            try {
                config.data = JSON.parse(data);
            } catch (e) {}
        } 
        else if ( $elem.attr('data-special') ) {
            let newData = $('body').attr('data-select-' + $elem.attr('data-special'));
            config.data = JSON.parse(newData);
        }

        if ( $elem.attr('data-template') ) {
            config.templateResult = selectTemplates[$elem.attr('data-template')];
        }
        if ( $elem.attr('data-template') ) {
            config.templateSelection = selectTemplates[$elem.attr('data-template-selection')];
        }

        if ( $elem.attr('data-nosearch') !== undefined ) {
            config.minimumResultsForSearch = Infinity;
        }

        const placeholder = $elem.attr('placeholder');
        $elem.removeAttr('placeholder');
        config.placeholder = placeholder || ' ';
        
        $elem.select2(config)
            .on('select2:clear', () => {
                $elem[0].cleared = true;
            })
            .on('select2:opening', e => {
                if ( $elem[0].cleared ) {
                    e.preventDefault();
                    $elem[0].cleared = false;
                }
            });
    });
    
    // advanced form controls
    // input-popover
    $('body').on('click', '.dropdown-menu-popover', e => {
        e.stopPropagation();
    });
    // inputPopover.apply();

    // button checkbox
    $('.btn-checkbox').on('click', e => {
        let input = $(e.target).prev()[0];
        input.checked = !input.checked;
    });

    $('#cookie-bar-accept').on('click', function (e) {
        functions.setCookie('cookie_usage', 'accepted');
        $("#cookie-bar").addClass('d-none');
    });

    $('.currency').on('click', function (e) {
        functions.setCookie('currency', $(this).data('currency'));
        location.reload();
    });

    // fancy cards
    $('.cards-fancy').on('click', '.card', e => {
        e.preventDefault();
        $(e.currentTarget).addClass('active').siblings().removeClass('active');
    });

    $(window).on('load', () => {

        // load slide images
        $('.slider li[data-style]').each((i, slide) => {
            slide.setAttribute('style', slide.getAttribute('data-style'));
        });

        // header off-screen
        //const header = $('.top-header')[0];
        const header = $('body:not(.page-type-details) .navbar')[0];
        const navbar = $('.navbar')[0];
        let scrolled = false;
        let lastScrollY = 0;
        const checkHeader = () => {
            if ( window.scrollY < lastScrollY ) {
                
                // header.classList.add('off-screen');



                // header.classList.remove('modal-transition');
                // header.classList.remove('modal-active');
                // navbar.classList.remove('show');
                // $(navbar).find('.show-dropdown').removeClass('show-dropdown');
            } else {
                // header.classList.remove('off-screen');
            }
            lastScrollY = window.scrollY;
        }

        // show/hide button for scroll to top
        const $btnScrollTop = $('.btn-scroll-top');
        const checkScrollTop = () => {
            $btnScrollTop.toggleClass('show', window.scrollY > 200);
        }
        checkScrollTop();

        let timer = 0;
        let timerBtn = 0;
        $(window).on('scroll', () => {
            if ( !scrolled ) { // annoying first scroll when page load already scrolled
                scrolled = true;
                return;
            } else {
                cancelAnimationFrame(timer);
                timer = requestAnimationFrame(checkHeader);
            }
            clearTimeout(timerBtn);
            timerBtn = setTimeout(checkScrollTop, 100);
        });

        $('.tab-item').on('click', function(){
            $('.tab-item').removeClass('active');
            $(this).addClass('active');
        });

        // if ($(".list").length) {
        //     let objectGroupId = $(".form-search").attr('data-objectGroupId');

        //     $.get('/services/list.php?perPage=12&objectGroupId=' + objectGroupId + '&language=' + functions.getLang()).then(response => {
        //         response = JSON.parse(response);
        //         $(".list").html(response.html);
        //         window.observer.observe();
        //         cardImageSlider();
        //     });
        // }


    });



});

